import {
  DataTable,
  DateField,
  List,
  ListActions,
  NeutralBadge,
  SearchInput,
} from "../common";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

export const HolidayList = () => (
  <List
    title="Holidays"
    filters={filters}
    actions={<ListActions label="Add Holiday" />}
    sort={{ field: "date", order: "ASC" }}
  >
    <div className="employees-table-container">
      <DataTable rowClick="edit" className="employees-table">
        <DataTable.Col source="date" label="Date">
          <DateField source="date" />
        </DataTable.Col>
        <DataTable.Col source="name" label="Holiday" className="employee-name" />
        <DataTable.Col label="Type">
          <NeutralBadge source="type" />
        </DataTable.Col>
      </DataTable>
    </div>
  </List>
);

